(function () {
  const form = document.querySelector("[data-filter-form]");
  if (!form) return;

  const formId = form.id;
  const inputs = document.querySelectorAll(
    '[data-filter-input], [data-filter-input][form="' + formId + '"]',
  );
  let debounceTimer;

  inputs.forEach((input) => {
    input.addEventListener("change", () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => form.submit(), 150);
    });
  });

  const sortButtons = document.querySelectorAll("[data-sort-option]");
  const sortInput = form.querySelector('input[name="sort_by"]');

  sortButtons.forEach((button) => {
    button.addEventListener("click", () => {
      if (!sortInput) return;
      sortInput.value = button.dataset.sortValue || "";
      form.submit();
    });
  });

  // Close details dropdown when clicking outside
  const dropdowns = document.querySelectorAll("[data-filter-dropdown]");
  document.addEventListener("click", (e) => {
    dropdowns.forEach((dropdown) => {
      if (!dropdown.contains(e.target)) {
        dropdown.removeAttribute("open");
      }
    });
  });
})();
